// extracted by mini-css-extract-plugin
export default {"root":"Search_root__EzIl5","input":"Search_input__AMHe6","icon__search":"Search_icon__search__yS6m+","icon__close":"Search_icon__close__jmgm7"};